export const dayOptions = ['M', 'T', 'W', 'T', 'F', 'S', 'S']
